// import jsondata from '../json/staticdata.json';

export function calculations(
  noOfContacts: any,
  avgContact: any,
  avgAgent: any,
  casesDeflected: any,
  handleTimes: any,
  agentProductivity: any,
  jsondata: any,
) {
  const noOfDaysPerYear = 365;
  const casesNotDeflected = 100 - casesDeflected;
  const laborCost = jsondata?.cost?.laborCost;
  const percentageOfUniqueUsers = 80;
  const inferenceChatbotCost =
    jsondata?.cost?.inferenceCostForClass1?.chatbotCost;
  const agentSummarizationCost =
    jsondata?.cost?.inferenceCostForClass1?.agentSummarizationCost;
  const otherCost = jsondata?.cost?.otherCostForClass1;
  const inferenceChatbotCompetitorCost =
    jsondata?.competitorCost?.['inferenceCostForOpenAITurbo3.5']?.chatbotCost;
  const summarizationChatbotCompetitorCost =
    jsondata?.competitorCost?.['inferenceCostForOpenAITurbo3.5']?.[
      'summarizationCostForOpenAITurbo3.5'
    ];
  const otherCompetitorCost =
    jsondata?.competitorCost?.['otherCostForOpenAITurbo3.5'];
  const noOfOperationalCasesDeflectedPerYear =
    (noOfContacts * casesDeflected) / 100;
  const noOfHandleTimesCasesNotDeflected =
    (noOfContacts * casesNotDeflected) / 100;
  const totalTimeOfProductivityContacts = noOfContacts * avgContact;
  const totalTimeOfoperationalDeflectedContacts =
    noOfOperationalCasesDeflectedPerYear * avgContact;

  const totalOperationalSavingsLow =
    (noOfOperationalCasesDeflectedPerYear /
      noOfDaysPerYear /
      laborCost?.avgCallsPerDay?.low) *
    laborCost?.avgFullyLoadedSalary?.low;
  const totalOperationalSavingsHigh =
    (noOfOperationalCasesDeflectedPerYear /
      noOfDaysPerYear /
      laborCost?.avgCallsPerDay?.high) *
    laborCost?.avgFullyLoadedSalary?.high;

  const inferenceChatbotCostPerMinLow =
    ((inferenceChatbotCost?.promptWordsPerMin?.low +
      inferenceChatbotCost?.wordsGenByChatbotPerMin?.low) *
      inferenceChatbotCost?.tokenPerWords?.low?.numerator *
      inferenceChatbotCost?.tokenPrice?.low) /
    (1000 * inferenceChatbotCost?.tokenPerWords?.low?.denominator);

  const inferenceChatbotCostPerMinHigh =
    ((inferenceChatbotCost?.promptWordsPerMin?.high +
      inferenceChatbotCost?.wordsGenByChatbotPerMin?.high) *
      inferenceChatbotCost?.tokenPerWords?.high?.numerator *
      inferenceChatbotCost?.tokenPrice?.high) /
    (1000 * inferenceChatbotCost?.tokenPerWords?.high?.denominator);

  const totalTuningCostLow =
    otherCost?.tuningCost?.low * otherCost?.tuningHours?.low;
  const hostingCostLow =
    otherCost?.hostingCost?.low * otherCost?.hostingHours?.low;
  const totalTuningCostHigh =
    otherCost?.tuningCost?.high * otherCost?.tuningHours?.high;
  const hostingCostHigh =
    otherCost?.hostingCost?.high * otherCost?.hostingHours?.high;
  const totalInferenceOperationalCostLow =
    totalTimeOfoperationalDeflectedContacts * inferenceChatbotCostPerMinLow;
  const totalInferenceOperationalCostHigh =
    totalTimeOfoperationalDeflectedContacts * inferenceChatbotCostPerMinHigh;

  const totalMaintenanceCostLow =
    otherCost?.totalMaintenanceAndEngineeringCost?.low;
  const totalMaintenanceCostHigh =
    otherCost?.totalMaintenanceAndEngineeringCost?.high;
  const noOfUniqueUsersDeflectedPerMonth =
    ((noOfOperationalCasesDeflectedPerYear / 12) * percentageOfUniqueUsers) /
    100;
  const uniqueUsersValueUpto50 = noOfUniqueUsersDeflectedPerMonth > 0 ? 1 : 0;
  const uniqueUsersValueOver50 =
    noOfUniqueUsersDeflectedPerMonth < 1
      ? 0
      : Math.max(
          0,
          Math.ceil((noOfUniqueUsersDeflectedPerMonth - 50000) / 1000), //used to be: Math.ceil((noOfUniqueUsersDeflectedPerMonth - 50000) / 1000, 0),
        );

  const totalWatsonCostLow =
    (uniqueUsersValueUpto50 * otherCost?.watsonEnterpriseFeeUnder50?.low +
      uniqueUsersValueOver50 * otherCost?.watsonEnterpriseFeeOver50?.low) *
    12;

  const totalWatsonCostHigh =
    (uniqueUsersValueUpto50 * otherCost?.watsonEnterpriseFeeUnder50?.high +
      uniqueUsersValueOver50 * otherCost?.watsonEnterpriseFeeOver50?.high) *
    12;
  const totalIBMCostLow =
    totalInferenceOperationalCostLow +
    totalTuningCostLow +
    hostingCostLow +
    totalMaintenanceCostLow;

  const totalIBMCostHigh =
    totalInferenceOperationalCostHigh +
    totalTuningCostHigh +
    hostingCostHigh +
    totalMaintenanceCostHigh;

  const inferenceCompetitorCostPerMinLow =
    (inferenceChatbotCompetitorCost?.promptWordsPerMin?.low *
      inferenceChatbotCompetitorCost?.tokenPerWords?.low?.numerator *
      inferenceChatbotCompetitorCost?.promptTokenPrice?.low +
      inferenceChatbotCompetitorCost?.wordsGenByChatbotPerMin?.low *
        inferenceChatbotCompetitorCost?.tokenPerWords?.low?.numerator *
        inferenceChatbotCompetitorCost?.completionTokenPrice?.low) /
    inferenceChatbotCompetitorCost?.tokenPerWords?.low?.denominator;
  const inferenceCompetitorCostPerMinHigh =
    (inferenceChatbotCompetitorCost?.promptWordsPerMin?.high *
      inferenceChatbotCompetitorCost?.tokenPerWords?.low?.numerator *
      inferenceChatbotCompetitorCost?.promptTokenPrice?.high +
      inferenceChatbotCompetitorCost?.wordsGenByChatbotPerMin?.high *
        inferenceChatbotCompetitorCost?.tokenPerWords?.low?.numerator *
        inferenceChatbotCompetitorCost?.completionTokenPrice?.high) /
    inferenceChatbotCompetitorCost?.tokenPerWords?.high?.denominator;

  const totalInferenceCostLow =
    (totalTimeOfoperationalDeflectedContacts *
      inferenceCompetitorCostPerMinLow) /
    1000;
  const totalInferenceCostHigh =
    (totalTimeOfoperationalDeflectedContacts *
      inferenceCompetitorCostPerMinHigh) /
    1000;

  const totalTuningCompetitorCostLow =
    otherCompetitorCost?.tuningCost?.low *
    otherCompetitorCost?.tuningHours?.low;
  const totalTuningCompetitorCostHigh =
    otherCompetitorCost?.tuningCost?.high *
    otherCompetitorCost?.tuningHours?.high;
  const totalHostingCompetitorCostLow =
    otherCompetitorCost?.hostingCost?.low *
    otherCompetitorCost?.hostingHours?.low;
  const totalHostingCompetitorCostHigh =
    otherCompetitorCost?.hostingCost?.high *
    otherCompetitorCost?.hostingHours?.high;
  const totalMaintenanceCompetitorCostLow =
    otherCompetitorCost?.totalMaintenanceAndEngineeringCost?.low;
  const totalMaintenanceCompetitorCostHigh =
    otherCompetitorCost?.totalMaintenanceAndEngineeringCost?.high;
  const serviceRepsLow = noOfContacts / 365 / laborCost?.avgCallsPerDay?.low;

  const serviceRepsHigh = noOfContacts / 365 / laborCost?.avgCallsPerDay?.high;

  const totalOperationalSubscriptionCostLow = Math.round(
    serviceRepsLow * 12 * otherCompetitorCost?.standardTierCost?.low,
  );
  const totalOperationalSubscriptionCostHigh = Math.round(
    serviceRepsHigh * 12 * otherCompetitorCost?.standardTierCost?.high,
  );
  const totalOperationalCostInputLow =
    (totalTimeOfoperationalDeflectedContacts *
      inferenceChatbotCompetitorCost?.promptWordsPerMin?.low *
      inferenceChatbotCompetitorCost?.tokenPerWords?.low?.numerator *
      inferenceChatbotCompetitorCost?.promptTokenPrice?.low) /
    (inferenceChatbotCompetitorCost?.tokenPerWords?.low?.denominator * 1000);
  const totalOperationalCostInputHigh =
    (totalTimeOfoperationalDeflectedContacts *
      inferenceChatbotCompetitorCost?.promptWordsPerMin?.high *
      inferenceChatbotCompetitorCost?.tokenPerWords?.high?.numerator *
      inferenceChatbotCompetitorCost?.promptTokenPrice?.high) /
    (inferenceChatbotCompetitorCost?.tokenPerWords?.high?.denominator * 1000);
  const totalOperationalCostOutputLow =
    (totalTimeOfoperationalDeflectedContacts *
      inferenceChatbotCompetitorCost?.wordsGenByChatbotPerMin?.low *
      inferenceChatbotCompetitorCost?.tokenPerWords?.low?.numerator *
      inferenceChatbotCompetitorCost?.completionTokenPrice?.low) /
    (inferenceChatbotCompetitorCost?.tokenPerWords?.low?.denominator * 1000);
  const totalOperationalCostOutputHigh =
    (totalTimeOfoperationalDeflectedContacts *
      inferenceChatbotCompetitorCost?.wordsGenByChatbotPerMin?.high *
      inferenceChatbotCompetitorCost?.tokenPerWords?.high?.numerator *
      inferenceChatbotCompetitorCost?.completionTokenPrice?.high) /
    (inferenceChatbotCompetitorCost?.tokenPerWords?.high?.denominator * 1000);
  const totalAnnualOperationalCompetitorCostLow =
    totalOperationalCostInputLow +
    totalOperationalCostOutputLow +
    totalTuningCompetitorCostLow +
    totalHostingCompetitorCostLow +
    totalMaintenanceCompetitorCostLow;
  const totalAnnualOperationalCompetitorCostHigh =
    totalOperationalCostInputHigh +
    totalOperationalCostOutputHigh +
    totalTuningCompetitorCostHigh +
    totalHostingCompetitorCostHigh +
    totalMaintenanceCompetitorCostHigh;
  const differenceOperationalCostLow =
    totalAnnualOperationalCompetitorCostLow - totalIBMCostLow;

  const differenceOperationalCostHigh =
    totalAnnualOperationalCompetitorCostHigh - totalIBMCostHigh;
  const avgHourlyPayOfServiceLow =
    laborCost?.avgFullyLoadedSalary?.low /
    laborCost?.daysWorkedPerYear?.low /
    laborCost?.hoursWorkedPerYear?.low;
  const avgHourlyPayOfServiceHigh =
    laborCost?.avgFullyLoadedSalary?.high /
    laborCost?.daysWorkedPerYear?.high /
    laborCost?.hoursWorkedPerYear?.high;

  const handleTimeCasesNoDeflected = (noOfContacts * casesNotDeflected) / 100;
  const handleTimeSavedPerContact = (handleTimes * avgContact) / 100;
  const handleTimeSavedOnContact =
    handleTimeCasesNoDeflected * handleTimeSavedPerContact;

  const totalSavingsHandleTimePerYearLow =
    (handleTimeSavedOnContact * laborCost?.hourlyPay?.low) / 60;
  const totalSavingsHandleTimePerYearHigh =
    (handleTimeSavedOnContact * laborCost?.hourlyPay?.high) / 60;
  const timeOnNotDeflectedContactLow =
    ((noOfContacts * casesNotDeflected) / 100) *
    ((avgContact *
      inferenceChatbotCost?.percentageOfTimeServiceUsesGenAI?.low) /
      100);
  const timeOnNotDeflectedContactHigh =
    ((noOfContacts * casesNotDeflected) / 100) *
    ((avgContact *
      inferenceChatbotCost?.percentageOfTimeServiceUsesGenAI?.high) /
      100);
  const annualIBMCostHandleTimeLow =
    timeOnNotDeflectedContactLow * inferenceChatbotCostPerMinLow;
  const annualIBMCostHandleTimeHigh =
    timeOnNotDeflectedContactHigh * inferenceChatbotCostPerMinHigh;
  const handleTimeValueLow1 =
    (inferenceChatbotCompetitorCost?.promptWordsPerMin?.low *
      inferenceChatbotCompetitorCost?.tokenPerWords?.low?.numerator *
      inferenceChatbotCompetitorCost?.promptTokenPrice?.low) /
    (1000 * inferenceChatbotCompetitorCost?.tokenPerWords?.low?.denominator);
  const handleTimeValueHigh1 =
    (inferenceChatbotCompetitorCost?.promptWordsPerMin?.high *
      inferenceChatbotCompetitorCost?.tokenPerWords?.high?.numerator *
      inferenceChatbotCompetitorCost?.promptTokenPrice?.high) /
    (1000 * inferenceChatbotCompetitorCost?.tokenPerWords?.high?.denominator);
  const totalInferenceCostHandleTimeInputLow =
    timeOnNotDeflectedContactLow * handleTimeValueLow1;

  const totalInferenceCostHandleTimeInputHigh =
    timeOnNotDeflectedContactHigh * handleTimeValueHigh1;
  const handleTimeValueLow =
    (inferenceChatbotCompetitorCost?.wordsGenByChatbotPerMin?.low *
      inferenceChatbotCompetitorCost?.tokenPerWords?.low?.numerator *
      inferenceChatbotCompetitorCost?.completionTokenPrice?.low) /
    (1000 * inferenceChatbotCompetitorCost?.tokenPerWords?.low?.denominator);

  const handleTimeValueHigh =
    (inferenceChatbotCompetitorCost?.wordsGenByChatbotPerMin?.high *
      inferenceChatbotCompetitorCost?.tokenPerWords?.high?.numerator *
      inferenceChatbotCompetitorCost?.completionTokenPrice?.high) /
    (1000 * inferenceChatbotCompetitorCost?.tokenPerWords?.high?.denominator);

  const totalInferenceCostHandleTimeOutputLow =
    timeOnNotDeflectedContactLow * handleTimeValueLow;
  const totalInferenceCostHandleTimeOutputHigh =
    timeOnNotDeflectedContactHigh * handleTimeValueHigh;
  const totalAnnualCompetitorCostLow =
    totalInferenceCostHandleTimeInputLow +
    totalInferenceCostHandleTimeOutputLow;
  const totalAnnualCompetitorCostHigh =
    totalInferenceCostHandleTimeInputHigh +
    totalInferenceCostHandleTimeOutputHigh;

  const differenceInHandleTimeLow =
    totalAnnualCompetitorCostLow - annualIBMCostHandleTimeLow;

  const differenceInHandleTimeHigh =
    totalAnnualCompetitorCostHigh - annualIBMCostHandleTimeHigh;
  const productivityTotalTimeOfContacts =
    avgContact * ((noOfContacts * casesNotDeflected) / 100);
  const productivityTimeSavedPerContact = (avgAgent * agentProductivity) / 100;

  const productivityTimeSavedOnCases =
    handleTimeCasesNoDeflected * productivityTimeSavedPerContact;

  const productivitySavingsPerYearLow =
    (productivityTimeSavedOnCases * laborCost?.hourlyPay?.low) / 60;
  const productivitySavingsPerYearHigh =
    (productivityTimeSavedOnCases * laborCost?.hourlyPay?.high) / 60;
  const productivityInferenceCostLow =
    ((agentSummarizationCost?.wordsPerMin?.low +
      agentSummarizationCost?.wordsPerSum?.low) *
      agentSummarizationCost?.tokenPerWords?.low?.numerator *
      agentSummarizationCost?.promptTokenPrice?.low) /
    (1000 * agentSummarizationCost?.tokenPerWords?.low?.denominator);

  const productivityInferenceCostHigh =
    ((agentSummarizationCost?.wordsPerMin?.high +
      agentSummarizationCost?.wordsPerSum?.high) *
      agentSummarizationCost?.tokenPerWords?.high?.numerator *
      agentSummarizationCost?.promptTokenPrice?.high) /
    (1000 * agentSummarizationCost?.tokenPerWords?.high?.denominator);

  const productivityInferenceCostLow1 =
    (agentSummarizationCost?.wordsPerMin?.low *
      agentSummarizationCost?.tokenPerWords?.low?.numerator *
      agentSummarizationCost?.promptTokenPrice?.low) /
    (1000 * agentSummarizationCost?.tokenPerWords?.low?.denominator);
  const productivityInferenceCostLow2 =
    (agentSummarizationCost?.wordsPerSum?.low *
      agentSummarizationCost?.tokenPerWords?.low?.numerator *
      agentSummarizationCost?.promptTokenPrice?.low) /
    (1000 * agentSummarizationCost?.tokenPerWords?.low?.denominator);
  const productivityAnnualIBMCostLow =
    productivityTotalTimeOfContacts * productivityInferenceCostLow1 +
    (noOfContacts * casesNotDeflected * productivityInferenceCostLow2) / 100;
  const productivityInferenceCostHigh1 =
    (agentSummarizationCost?.wordsPerMin?.high *
      agentSummarizationCost?.tokenPerWords?.high?.numerator *
      agentSummarizationCost?.promptTokenPrice?.high) /
    (1000 * agentSummarizationCost?.tokenPerWords?.high?.denominator);
  const productivityInferenceCostHigh2 =
    (agentSummarizationCost?.wordsPerSum?.high *
      agentSummarizationCost?.tokenPerWords?.high?.numerator *
      agentSummarizationCost?.promptTokenPrice?.high) /
    (1000 * agentSummarizationCost?.tokenPerWords?.high?.denominator);
  const productivityAnnualIBMCostHigh =
    productivityTotalTimeOfContacts * productivityInferenceCostHigh1 +
    (noOfContacts * casesNotDeflected * productivityInferenceCostHigh2) / 100;

  const valueLow1 =
    (summarizationChatbotCompetitorCost?.wordsPerMin?.low *
      summarizationChatbotCompetitorCost?.tokenPerWords?.low?.numerator *
      summarizationChatbotCompetitorCost?.promptTokenPrice?.low) /
    summarizationChatbotCompetitorCost?.tokenPerWords?.low?.denominator;

  const valueHigh1 =
    (summarizationChatbotCompetitorCost?.wordsPerMin?.high *
      summarizationChatbotCompetitorCost?.tokenPerWords?.high?.numerator *
      summarizationChatbotCompetitorCost?.promptTokenPrice?.high) /
    summarizationChatbotCompetitorCost?.tokenPerWords?.high?.denominator;
  const productivityInferenceCostInputLow =
    (productivityTotalTimeOfContacts * valueLow1) / 1000;
  const productivityInferenceCostInputHigh =
    (productivityTotalTimeOfContacts * valueHigh1) / 1000;
  const valueOutputLow1 =
    (summarizationChatbotCompetitorCost?.wordsPerSum?.low *
      summarizationChatbotCompetitorCost?.tokenPerWords?.low?.numerator *
      summarizationChatbotCompetitorCost?.completionTokenPrice?.low) /
    summarizationChatbotCompetitorCost?.tokenPerWords?.low?.denominator;
  const valueOutputHigh1 =
    (summarizationChatbotCompetitorCost?.wordsPerSum?.high *
      summarizationChatbotCompetitorCost?.tokenPerWords?.high?.numerator *
      summarizationChatbotCompetitorCost?.completionTokenPrice?.high) /
    summarizationChatbotCompetitorCost?.tokenPerWords?.high?.denominator;
  const productivityInferenceCostOutputLow =
    (noOfHandleTimesCasesNotDeflected * valueOutputLow1) / 1000;
  const productivityInferenceCostOutputHigh =
    (noOfHandleTimesCasesNotDeflected * valueOutputHigh1) / 1000;
  const productivityAnnualCompetitorCostLow =
    productivityInferenceCostInputLow + productivityInferenceCostOutputLow;
  const productivityAnnualCompetitorCostHigh =
    productivityInferenceCostInputHigh + productivityInferenceCostOutputHigh;
  const productivityCostDifferenceLow =
    productivityAnnualCompetitorCostLow - productivityAnnualIBMCostLow;

  const productivityCostDifferenceHigh =
    productivityAnnualCompetitorCostHigh - productivityAnnualIBMCostHigh;

  return {
    reduceOperationalCostLow: Math.round(totalOperationalSavingsLow),
    reduceOperationalCostHigh: Math.round(totalOperationalSavingsHigh),
    reduceHandleTimesLow: Math.round(totalSavingsHandleTimePerYearLow),
    reduceHandleTimesHigh: Math.round(totalSavingsHandleTimePerYearHigh),
    increaseProductivityLow: Math.round(productivitySavingsPerYearLow),
    increaseProductivityHigh: Math.round(productivitySavingsPerYearHigh),
    totalAnnualSavingsLow: Math.round(
      totalOperationalSavingsLow +
        totalSavingsHandleTimePerYearLow +
        productivitySavingsPerYearLow,
    ),
    totalAnnualSavingsHigh: Math.round(
      totalOperationalSavingsHigh +
        totalSavingsHandleTimePerYearHigh +
        productivitySavingsPerYearHigh,
    ),
    estimatedCostOfSavingsLow: Math.round(
      totalIBMCostLow +
        annualIBMCostHandleTimeLow +
        productivityAnnualIBMCostLow,
    ),
    estimatedCostOfSavingsHigh: Math.round(
      totalIBMCostHigh +
        annualIBMCostHandleTimeHigh +
        productivityAnnualIBMCostHigh,
    ),
    relativeCostSavingHigh: Math.round(
      Math.abs(
        differenceOperationalCostHigh +
          differenceInHandleTimeHigh +
          productivityCostDifferenceHigh,
      ),
    ),
    relativeCostSavingLow: Math.round(
      Math.abs(
        differenceOperationalCostLow +
          differenceInHandleTimeLow +
          productivityCostDifferenceLow,
      ),
    ),
  };
}
